import SetPassword from './components/SetPassword';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import get from 'lodash/get';

import { resetPasswordForUser } from '../../shared/redux/passwordReset/actions.js';

import './assets/SetPassword.css';

function mapStateToProps(state){
  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend,    
    isLoggedIn:get(state,['auth','token']) !== null,
    isLoaded:true,
    hasAdminPermission:true
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    resetPasswordForUser
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SetPassword));



// WEBPACK FOOTER //
// ./src/routes/SetPassword/index.js